import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { RouteInfo } from "./sidebar.metadata";
import { ROUTES } from "./menu-items";
import { EMPLOYEE_ROUTES } from "./employee-menu-item";
import { Globals } from "../../common/global";
import { RouteAccessService } from "../../services/route-access.service";

@Injectable({
  providedIn: "root",
})
export class SidebarService {
  public screenWidth: any;
  public collapseSidebar: boolean = false;
  public fullScreen: boolean = false;

  MENUITEMS: RouteInfo[] =
    localStorage.getItem("is_loginEmployee") == "true"
      ? this.routeService.getAuthorizedRoutes()
      : ROUTES;

  items = new BehaviorSubject<RouteInfo[]>(this.MENUITEMS);

  constructor(
    public globals: Globals,
    private routeService: RouteAccessService
  ) {}
}
